import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Address } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class AddressService {
  // private http = inject(HttpClient)
  core = inject(CoreService)

  public async getAddress(id): Promise<Address> {
    return new Address(
      await this.core.services.address.getById(id, {
        // todo
        id: null,
      })
    )
  }

  async getAddresses(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: Address[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.address.getList(parameters, schema)
  }

  createAddress(address: Partial<Address>, customer, schema = { id: null }): Promise<Address> {
    return this.core.services.address.create(address, customer, schema)
  }

  updateAddress(address: Partial<Address>, customer, schema = { id: null }): Promise<Address> {
    return this.core.services.address.update(address, customer, schema)
  }

  deleteAddress(address: Partial<Address>): Promise<Address> {
    return this.core.services.address.delete(address)
  }
}
